import React,{useEffect, useState} from 'react'
import {Container,Row,Col,Button} from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import Swal from 'sweetalert2'
import { getPlots, removePlot } from '../../../actions/plotsActions'
import { CustomDataTable } from '../../../components/design/Datatables/CustomDataTable'

export default function Plots() { 
    const { t } = useTranslation()
    const [isLoading, setIsLoading] = useState(true)
    const {plots, loading, result} = useSelector(state=>state.plots)
    const dispatch = useDispatch()

    useEffect(()=>{
        dispatch(getPlots())
    }, [dispatch])

    useEffect(()=>{
        setIsLoading(loading)
    }, [loading])

    useEffect(()=>{
        if(result != null){
            if(result !== 'ok'){
                Swal.fire({
                    showConfirmButton: true,
                    confirmButtonText: t('plots.itsok'),
                    icon: 'error',
                    text: t('plots.'+result.message+'0') + result.count + t('plots.'+result.message+'1')
                })
                dispatch({
                    type: 'PLOT_RESET_RESULT'
                })
            }else{
                Swal.fire({
                    showConfirmButton: true,
                    confirmButtonText: t('plots.letsok'),
                    icon: 'success',
                    text: t('plots.deletedplot')
                })
                dispatch({
                    type: 'PLOT_RESET_RESULT'
                })
            }
        }
    }, [result, t, dispatch])

    const deletePlot = (idPlot) => {
        Swal.fire({
            title: t('alert.areusure'),
            showDenyButton: true,
            confirmButtonText: t('alert.delete'),
            denyButtonText: t('alert.canceled'),
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(removePlot(idPlot))
                Swal.fire(t('alert.deleted'), '', 'success')
            }
        })
    }

    // Datatables
    const columns = [
        {
            name: t('plots.name'),
            cell: datos =>
                <div>
                    {datos.name}
                </div>,
            selector: (datos) => datos._id,
            sortable: true,
        },{
            name: '',
            cell: datos =>
            <>
                <Button variant="outline-info mx-auto" href={`/admin/plot/`+datos._id}>
                    <i className="fas fa-map-marked-alt"></i> <i className="fas fa-edit fa-sm"></i>
                </Button>
                <Button variant="outline-danger mx-auto" onClick={() => deletePlot(datos._id)}>
                    <i className="fas fa-map-marked-alt"></i> <i className="fas fa-minus fa-sm"></i>
                </Button>
            </>
        }
    ]
      
    return (
        <>
        {isLoading
        ?      
          <div className='d-flex justify-content-center vh-100'>            
              <span className="spinner-border spinner-border-sm" style={{width: "5rem",height: "5rem"}}></span>
          </div>
        : 
        <>        
            <Container className='cuerpo'>
                <Row className="text-left custom-card-header-list">
                    <Col>
                        <Button className="btn btn-secondary my-2 mx-auto float-right" href={`/admin/dashboard`}>
                            <i className="fas fa-arrow-circle-left"></i> {t('global.return')}
                        </Button>
                        <h1 className='mb-2'>{t('plots.editplot')}</h1> 
                        <label className='mb-2'>{t('plots.selectplot')}</label>
                        <Row className="custom-card-buttom">
                            <Button className="btn btn-secondary my-2 mx-auto" href={`/admin/plot`}>
                                <i className="fas fa-map-marked-alt"></i> {t('plots.new')}
                            </Button>
                        </Row>
                        <Row className="text-center justify-content-center">
                            {plots 
                                ?
                                    <CustomDataTable columns={columns} data={plots} />
                                :
                                    <></>
                            }
                        </Row>
                    </Col>
                </Row>
            </Container>
        </>
        }
        </>
    )
}